module.exports = __webpack_public_path__ + "static/media/28.71150822.mp3";